import { render, staticRenderFns } from "./ByRegion.vue?vue&type=template&id=03351bd6"
import script from "./ByRegion.vue?vue&type=script&lang=js"
export * from "./ByRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports